export default __webpack_public_path__ + "static/media/jcb.34e0fdf5.svg";